import { render, staticRenderFns } from "./AdminQuotes.vue?vue&type=template&id=48f98a11&scoped=true"
import script from "./AdminQuotes.vue?vue&type=script&lang=js"
export * from "./AdminQuotes.vue?vue&type=script&lang=js"
import style0 from "./AdminQuotes.vue?vue&type=style&index=0&id=48f98a11&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48f98a11",
  null
  
)

export default component.exports